// The alignment card in output px: a centred grid, border, diagonals, a circle that shows any stretch, corner targets.

// Major grid lines per card height.
const MAJOR = 8

const centredLines = (extent, step) => {
	const out = []
	for (let v = (extent / 2) % step; v <= extent; v += step) out.push(v)
	return out
}

/** The card's major grid lines over a W × H card, in its units. */
export const cardGrid = (W, H) => ({ xs: centredLines(W, H / MAJOR), ys: centredLines(H, H / MAJOR) })

export const drawTestCard = (canvas, W, H) => {
	canvas.width = W
	canvas.height = H
	const c = canvas.getContext('2d')
	const u = H / 512
	const cx = W / 2
	const cy = H / 2
	c.fillStyle = '#000'
	c.fillRect(0, 0, W, H)
	const grid = (step, stroke, width) => {
		c.beginPath()
		for (let x = cx % step; x <= W; x += step) {
			c.moveTo(x, 0)
			c.lineTo(x, H)
		}
		for (let y = cy % step; y <= H; y += step) {
			c.moveTo(0, y)
			c.lineTo(W, y)
		}
		c.strokeStyle = stroke
		c.lineWidth = width
		c.stroke()
	}
	grid(16 * u, '#262626', u)
	grid(H / MAJOR, '#666', 1.5 * u)
	c.strokeStyle = '#444'
	c.lineWidth = 1.5 * u
	c.beginPath()
	c.moveTo(0, 0)
	c.lineTo(W, H)
	c.moveTo(W, 0)
	c.lineTo(0, H)
	c.stroke()
	c.strokeStyle = '#fff'
	c.lineWidth = 2 * u
	c.beginPath()
	c.arc(cx, cy, cy - 32 * u, 0, Math.PI * 2)
	c.stroke()
	for (const [x, y] of [
		[64 * u, 64 * u],
		[W - 64 * u, 64 * u],
		[W - 64 * u, H - 64 * u],
		[64 * u, H - 64 * u],
	]) {
		c.beginPath()
		c.arc(x, y, 24 * u, 0, Math.PI * 2)
		c.stroke()
	}
	c.beginPath()
	c.moveTo(cx, 0)
	c.lineTo(cx, H)
	c.moveTo(0, cy)
	c.lineTo(W, cy)
	c.stroke()
	c.lineWidth = 4 * u
	c.strokeRect(2 * u, 2 * u, W - 4 * u, H - 4 * u)
	return canvas
}
